// extracted by mini-css-extract-plugin
export default {"date":"Birthday_date__N4a8l","time":"Birthday_time__FrHZo"};